// extracted by mini-css-extract-plugin
export default {"container":"tasks-closed_page_container__JXryb","headerContainer":"tasks-closed_page_headerContainer__xORpA"};